export default __webpack_public_path__ + "static/media/zoom.d9c6c142.svg";